import featureFlags from "./service";

const useFeatureFlag = () => {
	const entries = featureFlags.setupEntries();
	const features: any = new Map(entries);

	return {
		feature: {
			get: (code: string) => {
				const toggled = features.get(code);
				return toggled;
			},
		},
	};
};

export default useFeatureFlag;
